import React, { useState, useEffect, useRef, useCallback } from 'react';
import './TypingText.css';

function TypingText({ text, speed = 50, delay = 0, onComplete }) {
  const [displayedText, setDisplayedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const intervalRef = useRef(null);
  const indexRef = useRef(0);
  const onCompleteRef = useRef(onComplete);

  // Keep onComplete ref updated
  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    // Reset state
    setDisplayedText('');
    setIsComplete(false);
    indexRef.current = 0;

    // Clear any existing interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    const timeoutId = setTimeout(() => {
      intervalRef.current = setInterval(() => {
        if (indexRef.current < text.length) {
          indexRef.current++;
          setDisplayedText(text.slice(0, indexRef.current));
      } else {
          clearInterval(intervalRef.current);
        setIsComplete(true);
          if (onCompleteRef.current) onCompleteRef.current();
      }
      }, speed);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [text, speed, delay]);
  
  return (
    <span className={`typing-text ${isComplete ? 'typing-complete' : ''}`}>
      {displayedText}
      {!isComplete && <span className="typing-cursor">|</span>}
    </span>
  );
}

export default TypingText;
